import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import { TableContratosDataSource, TableContratosItem } from './table-contratos-datasource';
import { CrearContratoComponent } from '../../../clientes/crear-contrato/crear-contrato.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-table-contratos',
  templateUrl: './table-contratos.component.html',
  styleUrls: ['./table-contratos.component.scss']
})
export class TableContratosComponent implements AfterViewInit, OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<TableContratosItem>;
  dataSource: TableContratosDataSource;

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = [
    'numero', 
    'aplicacion', 
    'usuarios_permitidos', 
    'tipo_contrato', 
    'fecha_inicio',
    'fecha_fin',
    'acciones'
  ];

  constructor(public dialog: MatDialog){}

  ngOnInit() {
    this.dataSource = new TableContratosDataSource();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.table.dataSource = this.dataSource;
  }

  ejecutarFuncion(funcion = '') {
    const dialogRef = this.dialog.open(CrearContratoComponent, {
      width: '500px',
      height: '500px'
    });

  }
}
